module.exports = __webpack_public_path__ + "img/ac-desktop-hover.5a526d4e.png";